/**
 * Коды оценок, которые принимает backend
 * @type {{DISLIKE: string, OK: string, LIKE: string}}
 */
export const AdAssessmentCode = {
  DISLIKE: 'bad',
  OK: 'neutral',
  LIKE: 'good',
};

export default [
  '$q',
  '$http',
  'userService',
  'adListenerService',
  ($q, $http, userService, adListenerService) => {
    let isVisible = true;
    let isHomeowner = false;

    let idAssessment = null;
    let authorId = null;

    const getIsVisible = () => {
      return isVisible && isHomeowner;
    };

    const setIsVisible = flag => {
      isVisible = !!flag;
    };

    const sendRequest = (endpoint, requestData, callback) => {
      const deferred = $q.defer();

      $http({
        method: 'POST',
        url: endpoint,
        headers: { 'Content-Type': 'application/json' },
        data: requestData,
        allowServerErrors: true,
      })
        .then(successResponse => {
          if (successResponse && successResponse.data && successResponse.data.status === 'ok') {
            if (callback) {
              callback(successResponse.data.data);
            }

            deferred.resolve(successResponse);
          } else {
            deferred.reject(successResponse);
          }
        })
        .catch(errorResponse => {
          deferred.reject(errorResponse);
        });

      return deferred.promise;
    };

    /**
     * Только для собственников
     */
    adListenerService.$watch(
      ad => ad.isByHomeowner,
      isByHomeowner => {
        isHomeowner = isByHomeowner;
      },
    );

    return {
      AdAssessmentCode,
      /**
       * Отправляем код оценки
       * Положительный ответ:
       * {
       *   "status": "ok",
       *   "data": {
       *     "ticketId": 493442
       *   }
       * }
       * Ошибка в данных:
       * {
       *   "status": "validationError",
       *   "data": {
       *     "email": [
       *       {
       *         "message": "Missing data for required field.",
       *         "code": "required",
       *         "messageRu": "Укажите значение"
       *       }
       *     ],
       *     "name": [
       *       {
       *         "message": "Missing data for required field.",
       *         "code": "required",
       *         "messageRu": "Укажите значение"
       *       }
       *     ],
       *     "mark": [
       *       {
       *         "message": "Missing data for required field.",
       *         "code": "required",
       *         "messageRu": "Укажите значение"
       *       }
       *     ]
       *   }
       * }
       */
      sendAssessmentCode: assessmentCode => {
        return sendRequest(
          '/cian-api/site/v1/create-zendesk-ticket-as-feedback-from-homeowner/',
          {
            mark: assessmentCode,
          },
          data => {
            idAssessment = data.ticketId;
            authorId = data.submitterId;
          },
        );
      },
      /**
       * Отправляем текст для оценки
       */
      sendAssessmentText: ({ assessmentText }) => {
        return sendRequest('/cian-api/site/v1/update-zendesk-ticket-as-feedback-from-homeowner/', {
          comment: assessmentText,
          ticketId: idAssessment,
          authorId,
        });
      },
      getIsVisible,
      setIsVisible,
    };
  },
];
